import auth from '@/router/auth'
import ChapterCreate from '@/components/chapters/Create'
import ChapterUpdate from '@/components/chapters/Update'
import ChapterShow from '@/components/chapters/Show'

export default [
  {
    path: '/courses/:course_id/chapters/create',
    name: 'chapters-create',
    component: ChapterCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/update/:chapter_id',
    name: 'chapters-update',
    component: ChapterUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/show/:chapter_id',
    name: 'chapters-show',
    component: ChapterShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/chapters/router.js